import { render } from "./SectionSystemDetails.vue?vue&type=template&id=4b6ed691&scoped=true"
const script = {}

import "./SectionSystemDetails.vue?vue&type=style&index=0&id=4b6ed691&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6ed691"]])

export default __exports__